// src/pages/StockRemoval.js
import React from 'react';
import QueuePage from './QueuePage';
export default function StockRemoval() { return <QueuePage stage={2} />; }
